import CookieManager from 'utils/cookie_manager';

const COOKIE_NAME = '_my_consent_token';
const URLS = {
  development: 'https://ktocqilc49.execute-api.us-east-1.amazonaws.com/staging/consent',
  staging: 'https://ktocqilc49.execute-api.us-east-1.amazonaws.com/staging/consent',
  production: 'https://mmmos95aq3.execute-api.us-east-1.amazonaws.com/production/consent'
};

export default class ConsentManager {
  static async accept(user) {
    const token = await this.generateToken(user);

    if (token) {
      this.setToken(token);
    }
  }

  static isAccepted() {
    const token = this.getToken();

    return !!token;
  }

  static async generateToken(user) {
    const userId = user ? user.id : null;

    let token = null;

    try {
      const response = await $.ajax({
        url: URLS[RAILS_ENV],
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ user_id: userId })
      });

      return JSON.parse(response).token;
    } catch {
      return null;
    }
  }

  static setToken(token) {
    CookieManager.setPersistentCookie(COOKIE_NAME, token);
  }

  static getToken() {
    return CookieManager.getCookie(COOKIE_NAME);
  }
}
